import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import logo from '../images/logo.svg';

function PrivacyPolicyPage() {
  const { t } = useTranslation();

  return (
    <section className="privacy-policy content-panel" style={{ minHeight: '80vh' }}> 
      <div className="privacy-logo-container">
        <img src={logo} alt={t('sylentsLogoAlt')} className="privacy-logo" />
      </div>
      <h2 className="panel-title" style={{ color: '#17a4b0' }}>{t('privacyTitle')}</h2> 
      <div className="content">
        <div style={{ margin: '2rem 0' }}>
          <h4 style={{ color: '#17a4b0' }}>{t('privacyTitle')}</h4>
          <p style={{ lineHeight: '1.2' }}>{t('privacyIntro')}</p>
        </div>
        <div style={{ margin: '2rem 0' }}>
          <h4 style={{ color: '#17a4b0' }}>{t('privacyContactTitle', 'Contact')}</h4>
          <p style={{ lineHeight: '1.2' }}>{t('privacyContact')}</p>
        </div>
        <div style={{ margin: '2rem 0' }}>
          <h4 style={{ color: '#17a4b0' }}>{t('privacyDataCollectionTitle', 'Data Collection')}</h4>
          <p style={{ lineHeight: '1.2' }}>{t('privacyDataCollection')}</p>
        </div>
        <div style={{ margin: '2rem 0' }}>
          <h4 style={{ color: '#17a4b0' }}>{t('privacyCookiesTitle', 'Cookies')}</h4>
          <p style={{ lineHeight: '1.2' }}>{t('privacyCookies')}</p>
        </div>
        <div style={{ margin: '2rem 0' }}>
          <h4 style={{ color: '#17a4b0' }}>{t('privacyAnalyticsTitle', 'Analytics')}</h4>
          <p style={{ lineHeight: '1.2' }}>{t('privacyAnalytics')}</p>
        </div>
        <div style={{ margin: '2rem 0' }}>
          <h4 style={{ color: '#17a4b0' }}>{t('privacyRightsTitle', 'Your Rights')}</h4>
          <p style={{ lineHeight: '1.2' }}>{t('privacyRights')}</p>
        </div>
        <div style={{ margin: '2rem 0' }}>
          <h4 style={{ color: '#17a4b0' }}>{t('privacyAuthorityTitle', 'Authority & Contact')}</h4>
          <p style={{ lineHeight: '1.2' }}>{t('privacyAuthority')}</p>
        </div>
        <p style={{ marginTop: '2rem' }}><Link to="/">{t('privacyBackLink', t('imprintBackLink', 'Zurück zur Startseite'))}</Link></p>
      </div>
    </section>
  );
}

export default PrivacyPolicyPage; 